export * from './ActivityText'